import {
  ADMISSION_STATUS_ORDER,
  readableAdmissionStatus,
} from "../../../atoms/admission-status-tag";
import {WorkflowType} from "../../../atoms/start-workflow/types";
import {Status, WorkflowFilter} from "./types";

export const STATUSES: ReadonlyArray<Status> = [
  {id: null, label: "All"},
  ...ADMISSION_STATUS_ORDER.map(status => ({
    id: status,
    label: readableAdmissionStatus(status),
  })),
];

// Hardcoded to backend-supported workflow types only (admission + arbitration).
// TODO: Replace with dynamic options from facility template workflowTypes
// (see WorkflowService.getFacilityWorkflows) when backend supports all template keys.
export const WORKFLOW_FILTERS: ReadonlyArray<WorkflowFilter> = [
  {id: null, label: "All"},
  {id: WorkflowType.ADMISSION, label: "Admission"},
  {id: WorkflowType.ARBITRATION, label: "Arbitration"},
];

export const LIST_VIEW_KEY = "list-view";
export const TILE_VIEW_KEY = "tile-view";

/**
 * All possible view keys.
 */
export const VIEW_KEYS = [LIST_VIEW_KEY, TILE_VIEW_KEY];

/**
 * Class name for the active view used to manage styles.
 */
export const ACTIVE_VIEW_CLASS = "active-view";
